<mat-form-field
  [ngClass]="loading ? 'nsc-form-field-loading' : ''"
  [formGroup]="group"
  class="nsc-form-field-autocomplete">
  <input
    id="{{ idx }}"
    #itemFilterInput
    matInput
    autocomplete="off"
    formControlName="{{ controlName }}"
    placeholder="{{ placeholder }}"
    type="text"
    (blur)="onBlur()"
    (focus)="onFocus()"> 
    <div></div>
  <mat-card
    *ngIf="show.autocomplete"
    role="listbox"
    #optionList>
    <div></div>
    <mat-option
      *ngFor="let option of values.autocomplete; let i = index;"
      id="{{idx}}_{{i}}"
      [disabled]="option.disabled"
      [ngClass]="optionClass(i)"
      [value]="option.schlName"
      (click)="!option.disabled && selectOption(option)"
      (mouseenter)="optionHoverHandler($event, i)">
      {{ option.schlName }}
    </mat-option>
  </mat-card>
</mat-form-field>
